import { useTheme } from '@mui/material';

export const IdentityStepScanFaceIcon = () => {
    const theme = useTheme();
    const mainColour = theme.colors.other.icon.stroke.primary;
    const borderColour = theme.colors.other.icon.background.primary;

    return (
        <svg
            width="176"
            height="124"
            viewBox="0 0 176 124"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M32.9597 0.5H152C164.979 0.5 175.5 11.0213 175.5 24V100C175.5 112.979 164.979 123.5 152 123.5H32.9597C17.0155 123.5 5.69966 107.96 10.5946 92.7854L18.0991 69.5216C19.6766 64.6313 19.6766 59.3687 18.0991 54.4784L10.5946 31.2146C5.69966 16.0403 17.0155 0.5 32.9597 0.5Z"
                fill="white"
                stroke="url(#linear1)"
            />
            <rect x="70.5" y="18.5" width="45" height="45" rx="5.5" stroke={mainColour} />
            <rect x="80.5" y="18.5" width="25" height="45" stroke="white" />
            <rect
                x="116"
                y="28"
                width="26"
                height="46"
                transform="rotate(90 116 28)"
                fill="white"
            />
            <path
                d="M87.333 36.75V33.9167M98.6663 36.75V33.9167"
                stroke={mainColour}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M87.333 46.6667C88.9024 48.0377 90.9157 48.7932 92.9997 48.7932C95.0836 48.7932 97.0969 48.0377 98.6663 46.6667"
                stroke={mainColour}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="76.5" y="24.5" width="33" height="33" rx="3.5" stroke={mainColour} />
            <defs>
                <linearGradient
                    id="linear1"
                    x1="88"
                    y1="0"
                    x2="88"
                    y2="124"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.6" stopColor={borderColour} />
                    <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
